import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';

import blue from '@material-ui/core/colors/blue';

const theme = createTheme({
  palette: {
    primary: blue,
  },
  typography: {
    useNextVariants: true,
  },
});

class AppContainer extends Component {
  render() {
    return (
      <ThemeProvider theme={theme}>
        {this.props.children}
      </ThemeProvider>
    );
  }
}

export default AppContainer;